<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="7">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="6">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <v-img
                src="@/assets/img/company-logo/TFF_StackedLogo_BIL.png"
                alt="Terry Fox Foundation logo"
                contain
                height="100"
                class="mb-5"
                ref="tffLogo"
              ></v-img>

              <h3 class="text-center mb-3" translate>
                {{ $t(["Thank You for Supporting The Terry Fox Foundation"]) }}
              </h3>

              <div v-show="store.formSubmissionData.total > 0">
                <v-divider class="mt-3 mx-5"></v-divider>

                <v-simple-table class="mx-5">
                  <tbody>
                    <tr>
                      <td class="pl-15">
                        <b translate>{{ $t(["Status"]) }}</b>
                      </td>
                      <td class="pr-15">
                        <v-icon color="success">{{ checkmarkIcon }}</v-icon>
                        {{ $t(store.formSubmissionData.status) }}
                      </td>
                    </tr>

                    <tr>
                      <td class="pl-15">
                        <b translate>{{ $t(["Transaction ID"]) }}</b>
                      </td>
                      <td class="pr-15">
                        {{ store.formSubmissionData.merchantId }}
                      </td>
                    </tr>

                    <tr>
                      <td class="pl-15">
                        <b translate>{{ $t(["Amount"]) }}</b>
                      </td>
                      <td
                        class="pr-15"
                        v-html="
                          $t('Currency', {
                            amount: (store.formSubmissionData.total != undefined
                              ? store.formSubmissionData.total
                              : 0
                            ).toFixed(2),
                          })
                        "
                      />
                    </tr>
                  </tbody>
                </v-simple-table>

                <v-divider class="mb-3 mx-5"></v-divider>

                <p class="text-center receipt-tax-size mb-3 mx-3">
                  {{
                    $t([
                      "If applicable, a tax receipt will be sent at a later date",
                    ])
                  }}
                </p>

                <v-divider class="mb-3 mx-5"></v-divider>
              </div>

              <p class="px-5 mb-0" align="center">
                {{ $t(["Summary_Text_1"]) }}

                <br /><br />

                <span v-html="$t(['Summary_Text_2'])" />

                <br /><br />

                <span v-html="$t(['Summary_Text_3'])" />
              </p>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import { mdiCheckboxMarkedCircle } from "@mdi/js";
import { useFormDataStore } from "../../../store/formData.js";

export default {
  name: "S7_Summary",
  data: () => {
    return {
      checkmarkIcon: mdiCheckboxMarkedCircle,
    };
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
